import axios from "axios";
import {BASE_API_URL, paramHeadersPatch} from "../../app/AppConfig";
import {LocalParams} from "../../components/LocalParams";
import {PutItemToCartOfferRequest} from "../Entity/PutItemToCartRequest";
import {Cart, CartDto} from "../Entity/Cart";
import {GetCurrentLocale} from "../../components/Utils";

export async function createCartRep(locale: string, userEmail: string|null): Promise<Cart> {
  try {
    const userToken = LocalParams.getItem("token");
    const response = await axios.post<Cart>(
      `${BASE_API_URL}/orders`,
    {
        'localeCode' : locale,
        'email' : userEmail
      },
      userToken ? {headers: {Authorization: 'Bearer ' + userToken}} : undefined
    );
    LocalParams.setItem('tokenCart', response.data.tokenValue);
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}

export async function getCartRep(tokenCart : string): Promise<Cart> {
  try {
    const userToken = LocalParams.getItem("token");
    const response = await axios.get<Cart>(
      `${BASE_API_URL}/orders/${tokenCart}?locale=${GetCurrentLocale()}`,
      userToken ? {headers: {Authorization: 'Bearer ' + userToken}} : undefined
    );
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}

export async function addItemInCartRep( cartData: PutItemToCartOfferRequest, tokenCart: string): Promise<Cart> {
  try {
    const userToken = LocalParams.getItem("token");
    const response = await axios.post<Cart>(
      `${BASE_API_URL}/orders/${tokenCart}/items`,
      {
        'orderTokenValue' : cartData.tokenValue,
        'productVariant' : cartData.variantCode,
        'quantity' : parseInt(cartData.quantity as any, 10)
      },
      userToken ? {headers: {Authorization: 'Bearer ' + userToken}} : undefined
    )
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}

export async function removeItemFromCartRep(tokenCart: string, itemId: number): Promise<Cart> {
  try {
    const userToken = LocalParams.getItem("token");

    const response = await axios.delete<Cart>(
      `${BASE_API_URL}/orders/${tokenCart}/items/${itemId}`,
      userToken ? {headers: {Authorization: 'Bearer ' + userToken}} : undefined
    );
    const responseGetCart = await axios.get<Cart>(
      `${BASE_API_URL}/orders/${tokenCart}?locale=${GetCurrentLocale()}`,
      userToken ? {headers: {Authorization: 'Bearer ' + userToken}} : undefined
    );
    return responseGetCart.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}

export async function changeQuantityItemInCartRep(tokenCart: string, orderItemId: number, quantity: number): Promise<Cart> {
  try {
    const userToken = LocalParams.getItem("token");
    const headers = userToken ? {...paramHeadersPatch, Authorization: 'Bearer ' + userToken } : paramHeadersPatch;
    const response = await axios.patch<Cart>(
      `${BASE_API_URL}/orders/${tokenCart}/items/${orderItemId}`,
      {quantity: quantity},
      {headers: headers}
    );
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}

export async function submitCartRep(
  cartData: CartDto,
  tokenCart: string,
): Promise<CartDto> {
  const tokenUser = LocalParams.getItem('token') as string;
  const tokenOfferCart = LocalParams.getItem('tokenOfferCart') as string;

  const headersJson = {
    'Content-Type': 'application/json',
    ...(tokenUser && { Authorization: 'Bearer ' + tokenUser })
  };

  const headersMergePatch = {
    'Content-Type': 'application/merge-patch+json',
    ...(tokenUser && { Authorization: 'Bearer ' + tokenUser })
  };

  try {

    await axios.put(
      `${BASE_API_URL}/orders/${tokenCart}`,
      {
        billingAddressId: cartData.billingAddressId,
        services: cartData.service ?? null,
        orderRemark: cartData.remark ?? ""
      },
      { headers: headersJson }
    );

    const response = await axios.patch<CartDto>(
      `${BASE_API_URL}/orders/${tokenCart}/complete`,
      {
        notes: cartData.notes ?? "",
        email: cartData.email
      },
      { headers: headersMergePatch }
    );

    LocalParams.removeItem('tokenCart');
    if (tokenOfferCart) {
      LocalParams.removeItem('tokenOfferCart');
    }

    return response.data;
  } catch (err: any) {
    throw {
      code: err?.response?.data?.code ?? 'UNKNOWN',
      message: err?.response?.data?.message ?? 'Erreur inconnue'
    };
  }
}

